import { Box } from "@mui/system";
import React, { useRef } from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import {ImageList, ImageListItem, IconButton } from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import WestIcon from "@mui/icons-material/West";
import SectionHeader from "./SectionHeader";
import { GallaryImgData } from "../../api/HomeApi";

const style = {
  MainContainer: {
    width: "100%",

    overflow: "hidden",
    paddingTop: {
      xl: "70px",
      md: "70px",
      sm: "50px",
      xs: "50px",
    },
    position: "relative",
    height: "auto",
    backgroundColor: "#fff",
    display: "flex",

    flexDirection: "column",
    alignItems: "center",
  },

  sliderContainer: {
    overflow: "hidden",
    position: "relative",
    width: { xs: "100%", sm: "98%" },
    height: "513px",
  },
  ButtonContainer: {
    display: "flex",
    justifyContent: "center",
    gap: "20px",
    marginTop: "40px",
  },
  SliderButton: {
    width: "50px",
    height: "50px",
    border: "1px solid #E1D9CF",
    color: "#E1D9CF",
    borderRadius: "0",
  },
  controlBtn: {
    btn: {
      width: { xs: "40px", sm: "50px" },
      height: { xs: "40px", sm: "50px" },
      border: "1px solid #E1D9CF",
      color: "#E1D9CF",
      borderRadius: 0,
    },
    left: {
      position: "absolute",
      left: { xs: "8%", sm: "-10%" },
    },
    right: {
      position: "absolute",
      right: { xs: "8%", sm: "20%" },
    },
  },
};

const settings = {
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  easing: "ease-in-out",
  swipeToSlide: true,
  draggable: true,
  responsive: [
    {
      breakpoint: 1440,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: "10%", // Reduced center padding for smaller viewports
      },
    },
  ],
};

const Gallary = () => {
  const sliderRef = useRef(null);

  const handlePrev = () => {
    sliderRef.current.slickPrev();
  };

  const handleNext = () => {
    sliderRef.current.slickNext();
  };

  const chunkImages = (images) => {
    const columns = Array.from({ length: 4 }, () => []);
    let currentColumn = 0;

    images.forEach((image, index) => {
      columns[currentColumn].push(image);
      currentColumn = (currentColumn + 1) % 4;
    });

    return columns;
  };

  const slides = chunkImages(GallaryImgData).map((column, index) => (
    <Box key={index}>
      <ImageList variant="masonry" cols={1} gap={10}>
        {column.map((item, idx) => (
          <ImageListItem key={idx} sx={{ overflow: "hidden", ml: 1 }}>
            <img
              src={item.src}
              alt=""
              loading="lazy"
              style={{
                height: `${item.height}px`,
              }}
            />
          </ImageListItem>
        ))}
      </ImageList>
    </Box>
  ));

  return (
    <Box sx={style.MainContainer}>
      <SectionHeader
        title={"GALLERY"}
        description={"A Glimpse Into Your Luxurious Escape"}
      />
      <Box sx={style.sliderContainer}>
        <Slider {...settings} ref={sliderRef}>
          {slides}
        </Slider>
      </Box>

      <Box sx={style.ButtonContainer}>
        <IconButton
          disableRipple
          sx={{
            ...style.controlBtn.btn,
            ...style.controlBtn.left,
            display: "flex",
            justContent: "center",
            alignItems: "center",

            cursor: "pointer",
            background: "transparent",
            position: "relative",
            overflow: "hidden",
            zIndex: 1,
            transition: "ease 0.1s",
            "&::before": {
              content: '""',
              position: "absolute",
              height: "100%",
              width: "0%",
              top: 0,
              right: "-40px",
              backgroundColor: "#E4CAAE",
              zIndex: -1,
              transition: "all 1s",
            },
            "&:hover": {
              color: "#A88765",
            },
            "&:hover::before": {
              width: "200%",
            },
          }}
          onClick={handlePrev}
        >
          <WestIcon />
        </IconButton>

        <IconButton
          disableRipple
          sx={{
            ...style.controlBtn.btn,
            ...style.controlBtn.right,
            display: "flex",
            justContent: "center",
            alignItems: "center",

            cursor: "pointer",
            background: "transparent",
            position: "relative",
            overflow: "hidden",
            zIndex: 1,
            transition: "ease 0.1s",
            "&::before": {
              content: '""',
              position: "absolute",
              height: "100%",
              width: "0%",
              top: 0,
              left: "-40px",
              backgroundColor: "#E4CAAE",
              zIndex: -1,
              transition: "all 1s",
            },
            "&:hover": {
              color: "#A88765",
            },
            "&:hover::before": {
              width: "200%",
            },
          }}
          onClick={handleNext}
        >
          <EastIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Gallary;
